import styled from 'styled-components';
import { IconClose } from '../icon/IconClose';
import { IconInfo } from '../icon/IconInfo';
import { IconButton } from '../input/IconButton';
import { Flex } from '../layout/Flex';
import { Typography } from '../typography/Typography';

const Container = styled(Flex).attrs({
    direction: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    p: 1 / 2,
    pl: 1.5,
    width: '100%',
    borderRadius: '999px',
    wrap: 'wrap',
    spacing: 1,
})`
    color: #ffffff;
    background-color: rgba(50, 50, 50, 0.5);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
`;

interface SnackbarProps {
    message: string;
    onRemove: VoidFunction;
}

export const Snackbar = (props: SnackbarProps) => {
    const { message, onRemove } = props;

    return (
        <Container>
            <IconInfo size={20} />
            <Typography variant="body3" color="inherit" mr="auto">
                {message}
            </Typography>
            <IconButton size="s" onClick={onRemove}>
                <IconClose fill="#FFFFFF" />
            </IconButton>
        </Container>
    );
};
